// Minimal native-Date helpers replacing moment for this app's handful of needs.
// Each mirrors the exact moment behavior it replaces (see callers); kept tiny and
// pure so the age-gate / expiry paths stay testable. See src/utils/date.test.js.

export const pad2 = (n) => String(n).padStart(2, '0');

// MM/DD/YYYY in local time — matches moment(d).format('MM/DD/YYYY').
export const formatMDY = (d) =>
    d instanceof Date && !isNaN(d)
        ? `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()}`
        : '';

// YYYYMMDD in local time — matches moment(d).format('YYYYMMDD').
export const formatYMD = (d) =>
    `${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}`;

// UTC iCalendar stamp YYYYMMDDTHHMMSSZ — matches moment().utc().format('YYYYMMDD[T]HHmmss[Z]').
export const icsStampUTC = (d = new Date()) =>
    d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

// Whole completed months from `earlier` to `later` — matches
// moment(later).diff(earlier, 'months') (used by the 21+ age gate).
export const monthsBetween = (later, earlier) => {
    let m =
        (later.getFullYear() - earlier.getFullYear()) * 12 +
        (later.getMonth() - earlier.getMonth());
    if (later.getDate() < earlier.getDate()) m -= 1;
    return m;
};
